import { makeStyles } from '@material-ui/core/styles';

import theme from '../MaterialUi/MaterialUi';

const drawerWidth = 0;

const useStyles = makeStyles({
	navbar: {
		backgroundColor: theme.palette.primary.main,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		[theme.breakpoints.down('xs')]: {
			width: `calc(100% - ${drawerWidth}px)`,
			marginLeft: drawerWidth,
		},
	},
	logo: {
		height: '4em',
	},
	menuButton: {
		margin: theme.spacing(2),
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.light,
		'&:hover': {
			backgroundColor: theme.palette.primary.dark,
		},
		[theme.breakpoints.down('xs')]: {
			flexGrow: '0',
		},
	},
});

export default useStyles;
